<div *ngIf="!authService.isLatest()" class="update-alert">
  <h5 class="title">AQMeshData.net update</h5>
  <p class="text">To get the latest features refresh your browser using <strong>CTRL</strong> +
    <strong>F5</strong> for Windows<br />or <strong>Opt</strong> + <strong>Cmd</strong> + <strong>E</strong> for
    Safari on Mac
  </p>
  <div style="text-align:center; text-decoration: underline;">
    <a (click)="forceRefresh()" style="cursor:pointer;">or Click here</a>
  </div>
</div>

<div class="action-alert" *ngIf="showActionMessage">
  <h5 class="title">IMPORTANT</h5>
  <p class="text">You have <strong>important actions</strong> that need your attention.</p>
  <div class="p-grid">
    <div class="p-col-12 p-d-flex p-jc-between">
      <div class="p-col-6" style="text-align: center;">
        <a (click)="goToActions()" style="cursor:pointer; text-decoration: underline;">Go to actions</a>
      </div>
      <div class="p-col-6" style="text-align: center;">
        <a (click)="closeActionMessage()" style="cursor:pointer; text-decoration: underline;">Ignore</a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="authService.inMaint() || inMaint">
  <div>
    <div style="margin:10px 0px 50px 15px;">
      <img src="./assets/aq-mesh-data-logo.png" width="350">
    </div>
    <div style="margin-top: 5%;">
      <p class="maintMessage">AQMeshData.net is currently unavailable and we apologise for the inconvenience.
        <br>If you would like to be informed when the site is accessible please
        <br>
        <span><a class="hyperLink" href="https://www.aqmesh.com/user-maintenance-alert">click here</a></span>
        to leave your email address.
        <br>
      </p>
    </div>
    <hr>
    <div>
      <p class="maintMessage">
        <span><a class="hyperLink" onclick="window.location.href=window.location.href">Click here to try again (or use
            Ctrl + F5 to force refresh).</a></span>
      </p>
    </div>
    <hr>
  </div>
</div>

<div class="p-grid content" *ngIf="!authService.inMaint() && showActionMessage" [ngClass]="{'disableUI': showActionMessage}"></div>

<div class="p-grid content" *ngIf="!authService.inMaint() && !showActionMessage">
  <div class="p-flex-column p-col-12">
    <div class="p-d-flex p-jc-between" style="height:120px;">
      <app-header class="p-col"></app-header>
      <app-navbar class="p-col"></app-navbar>
    </div>
    <div *ngIf="showMaintMessage" class="maint-alert">
      <div style="float: right; margin-right: 5px;">
        <a (click)="closeMaintMessage()"><i class="far fa-times-circle"></i></a>
      </div>
      <h5 class="title">AQMeshData.net Maintenance</h5>
      <p class="text">{{message}}</p>
    </div>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <p-toast life="10000"></p-toast>
    <session-timeout-component></session-timeout-component>
    <cookie-warning></cookie-warning>
  </div>
</div>
